<template>
  <div>
    <div class="card-footer text-muted p-0 m-0" style="background: white">
      <vs-row class="my-2">
        <vs-col sm="12" lg="9" class="d-flex infoStatus">
          <div class="colorStatus aprobada">
            <div class="valorEstatus" style="background-image: url(/img/mapa/aprobada-group.png); " />
          </div>
          <p class="mb-0 mr-2"> Aprobada</p>
          
          <div class="colorStatus no-aprobada">
            <div class="valorEstatus" style="background-image: url(/img/mapa/no-aprobada-group.png); " />
          </div>
          <p class="mb-0 mr-2">No aprobada</p>
          
          <div class="colorStatus vigente">
            <div class="valorEstatus" style="background-image: url(/img/mapa/inscrita-group.png); " />
          </div>
          <p class="mb-0 mr-2">Vigente en ciclo escolar</p>
          
          <div class="colorStatus disponible">
            <div class="valorEstatus" style="background-image: url(/img/mapa/disponible-group.png); " />
          </div>
          <p class="mb-0 mr-2">Disponible</p>

          <div class="colorStatus no-disponible">
            <div class="valorEstatus" style="background-image: url(/img/mapa/no-disponible-group.png); " />
          </div>
          <p class="mb-0 mr-2">No disponible por seriación, niveles o créditos</p>
        </vs-col>
        <vs-col sm="12" lg="3">

        </vs-col>
      </vs-row>
      <div>
        <table class="table">
          <tbody>
            <tr v-for="(area, i) in materias.areas" :key="i">
              <td class="d-flex" style="background: white;">
                <div class="cabecera mr-3" style="display: flex; align-items: center">
                    <span><strong>{{ area.area }}</strong></span>
                </div>
                <vs-row>
                  <vs-col class="materias" v-for="asignatura in area.asignaturas" :key="asignatura.asignatura_id">
                      <div @click="activeModal(asignatura.status), selectInfo = asignatura"  data-toggle="tooltip" data-placement="top" title="Tooltip on top">
                          <div :class="'nombreMateria asignatura asig-' + asignatura.status">
                            <div class="imgDalto" :style="'background-image: url(/img/mapa/' + asignatura.status + '.png);'">
                            </div>
                            <div style="width: 93%" class="text-center">
                              <span class="text-center m-2 text-uppercase">{{ asignatura.asignatura }} ({{asignatura.clave}})</span>
                            </div>
                          </div>
                          
                          <vs-row class="borderInfo" v-if="asignatura.status == 'no-disponible'">
                            <vs-col w="12">
                              <p class="mb-0"><small><strong>{{asignatura.descripcion_status_asignatura ? asignatura.descripcion_status_asignatura : 'No disponible por seriación'}}</strong></small></p>
                            </vs-col>
                          </vs-row>
                          <vs-row class="borderInfo" v-else>
                            <vs-col w="4">
                              <p><small>{{asignatura.creditos}}</small></p>
                            </vs-col>
                            <vs-col w="4">
                              <p><small>{{asignatura.cupo}}</small></p>
                            </vs-col>
                          </vs-row>
                      </div>
                  </vs-col>
                </vs-row>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      
    </div>
    <inscribir v-model="activeAsignatura" :row="selectInfo"></inscribir>
    <aprobada v-model="activeInformacion" :row="selectInfo"></aprobada>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import inscribir from './modal/inscribir.vue'
import aprobada from './modal/aprobada-no-aprobada.vue'
export default {
  components: {
    draggable,
    inscribir,
    aprobada
  },
  props: [
    'materias'
  ],
  data() {
    return {
        enabled: true,
        selectInfo: [],
        activeAsignatura: false,
        activeInformacion: false,
        list: [
          {
            "id": 1,
            "nombre": "1",
            "asignaturas": [
              {
                "id": 2,
                "clave": "102",
                "nombre": "Introducción al Pensamiento Social y Político Moderno",
                "estatus": "aprobada",
                "orden": 0,
                "horarios": [
                  {
                    "profesor": "Juan Díaz",
                    "matricula": "DIJU8765",
                    "fecha": "Lunes",
                    "hora": "9:00 - 10:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "4",
                    "salon": "106"
                  },
                  {
                    "profesor": "Marijosé Salazar",
                    "matricula": "SAMA2365",
                    "fecha": "Lunes",
                    "hora": "14:00 - 15:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "1",
                    "salon": "106"
                  }
                ]
              },
              {
                "id": 1,
                "clave": "101",
                "nombre": "Economía",
                "estatus": "aprobada",
                "orden": 1,
                "horarios": [
                  {
                    "profesor": "Juan Díaz",
                    "matricula": "DIJU8765",
                    "fecha": "Lunes",
                    "hora": "9:00 - 10:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "4",
                    "salon": "106"
                  },
                  {
                    "profesor": "Marijosé Salazar",
                    "matricula": "SAMA2365",
                    "fecha": "Lunes",
                    "hora": "14:00 - 15:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "1",
                    "salon": "106"
                  }
                ]
              },
              {
                "id": 3,
                "clave": "101",
                "nombre": "Lenguaje, Cultura y Poder",
                "estatus": "no-aprobada",
                "orden": 3,
                "horarios": [
                  {
                    "profesor": "Juan Díaz",
                    "matricula": "DIJU8765",
                    "fecha": "Lunes",
                    "hora": "9:00 - 10:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "4",
                    "salon": "106"
                  },
                  {
                    "profesor": "Marijosé Salazar",
                    "matricula": "SAMA2365",
                    "fecha": "Lunes",
                    "hora": "14:00 - 15:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "1",
                    "salon": "106"
                  }
                ]
              },
              {
                "id": 3,
                "clave": "102",
                "nombre": "Teorías de la Comunicación I",
                "estatus": "aprobada",
                "orden": 0,
                "horarios": [
                  {
                    "profesor": "Juan Díaz",
                    "matricula": "DIJU8765",
                    "fecha": "Lunes",
                    "hora": "9:00 - 10:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "4",
                    "salon": "106"
                  },
                  {
                    "profesor": "Marijosé Salazar",
                    "matricula": "SAMA2365",
                    "fecha": "Lunes",
                    "hora": "14:00 - 15:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "1",
                    "salon": "106"
                  }
                ]
              },
              {
                "id": 4,
                "clave": "101",
                "nombre": " Estado, Sociedad y Derecho",
                "estatus": "aprobada",
                "orden": 1,
                "horarios": [
                  {
                    "profesor": "Juan Díaz",
                    "matricula": "DIJU8765",
                    "fecha": "Lunes",
                    "hora": "9:00 - 10:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "4",
                    "salon": "106"
                  },
                  {
                    "profesor": "Marijosé Salazar",
                    "matricula": "SAMA2365",
                    "fecha": "Lunes",
                    "hora": "14:00 - 15:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "1",
                    "salon": "106"
                  }
                ]
              },
            ]
          },
          {
            "id": 2,
            "nombre": "2",
            "asignaturas": [
              {
                "id": 3,
                "clave": "102",
                "nombre": "Teorías de la Comunicación II",
                "estatus": "acreditada",
                "orden": 0,
                "horarios": [
                  {
                    "profesor": "Juan Díaz",
                    "matricula": "DIJU8765",
                    "fecha": "Lunes",
                    "hora": "9:00 - 10:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "4",
                    "salon": "106"
                  },
                  {
                    "profesor": "Marijosé Salazar",
                    "matricula": "SAMA2365",
                    "fecha": "Lunes",
                    "hora": "14:00 - 15:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "1",
                    "salon": "106"
                  }
                ]
              },
              {
                "id": 4,
                "clave": "101",
                "nombre": " Estado, Sociedad y Derecho II",
                "estatus": "inscrita",
                "orden": 1,
                "horarios": [
                  {
                    "profesor": "Juan Díaz",
                    "matricula": "DIJU8765",
                    "fecha": "Lunes",
                    "hora": "9:00 - 10:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "4",
                    "salon": "106"
                  },
                  {
                    "profesor": "Marijosé Salazar",
                    "matricula": "SAMA2365",
                    "fecha": "Lunes",
                    "hora": "14:00 - 15:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "1",
                    "salon": "106"
                  }
                ]
              },
              {
                "id": 6,
                "clave": "101",
                "nombre": "Argumentación y Expresión Escrita II",
                "estatus": "no-disponible",
                "orden": 9,
                "horarios": [
                  {
                    "profesor": "Juan Díaz",
                    "matricula": "DIJU8765",
                    "fecha": "Lunes",
                    "hora": "9:00 - 10:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "4",
                    "salon": "106"
                  },
                  {
                    "profesor": "Marijosé Salazar",
                    "matricula": "SAMA2365",
                    "fecha": "Lunes",
                    "hora": "14:00 - 15:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "1",
                    "salon": "106"
                  }
                ]
              }
            ]
          },
          {
            "id": 3,
            "nombre": "3",
            "asignaturas": [
              {
                "id": 3,
                "clave": "102",
                "nombre": "Biología",
                "estatus": "acreditada",
                "orden": 0,
                "horarios": [
                  {
                    "profesor": "Juan Díaz",
                    "matricula": "DIJU8765",
                    "fecha": "Lunes",
                    "hora": "9:00 - 10:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "4",
                    "salon": "106"
                  },
                  {
                    "profesor": "Marijosé Salazar",
                    "matricula": "SAMA2365",
                    "fecha": "Lunes",
                    "hora": "14:00 - 15:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "1",
                    "salon": "106"
                  }
                ]
              },
              {
                "id": 4,
                "clave": "101",
                "nombre": "Ciencias de la Tierra",
                "estatus": "no-aprobada",
                "orden": 1,
                "horarios": [
                  {
                    "profesor": "Juan Díaz",
                    "matricula": "DIJU8765",
                    "fecha": "Lunes",
                    "hora": "9:00 - 10:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "4",
                    "salon": "106"
                  },
                  {
                    "profesor": "Marijosé Salazar",
                    "matricula": "SAMA2365",
                    "fecha": "Lunes",
                    "hora": "14:00 - 15:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "1",
                    "salon": "106"
                  }
                ]
              },
              {
                "id": 6,
                "clave": "101",
                "nombre": "Biomedicina",
                "estatus": "disponible",
                "orden": 9,
                "horarios": [
                  {
                    "profesor": "Juan Díaz",
                    "matricula": "DIJU8765",
                    "fecha": "Lunes",
                    "hora": "9:00 - 10:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "4",
                    "salon": "106"
                  },
                  {
                    "profesor": "Marijosé Salazar",
                    "matricula": "SAMA2365",
                    "fecha": "Lunes",
                    "hora": "14:00 - 15:00",
                    "cupo": "30",
                    "cupo_no_dispoble": "1",
                    "salon": "106"
                  }
                ]
              }
            ]
          }
        ],
        dragging: false
    };
  },
  methods: {
    activeModal(status){
      if(status == 'disponible'){
        this.activeAsignatura =! this.activeAsignatura
      }
      if(status == 'aprobada' || status == 'no-aprobada'){
        this.activeInformacion =! this.activeInformacion
      }
    },
    checkMove: function(e) {
        console.log(e.draggedContext.element)
        window.console.log("Future index: " + e.draggedContext.futureIndex);
    }
  }
};
</script>
<style lang="scss" scoped>
  .infoStatus{
    p{
      font-size: 11px;
      font-weight: 500;
    }
    .colorStatus{
      width: 20px;
      height: 20px;
      float: left;
      &.aprobada{
        background: yellowgreen;
        margin-right: 5px;
      }
      &.no-aprobada{
        background-color:#EB5757;
        margin-right: 5px;
      }
      &.vigente{
        background-color:#F2994A;
        margin-right: 5px;
      }
      &.disponible{
        background-color:#BB6BD9;
        margin-right: 5px;
      }
      &.no-disponible{
        background-color:#828282;
        margin-right: 5px;
      }
    }
  }
  .imgDalto{
    width: 5%;
    height: 100%;
    background-size: contain;
  }
  .valorEstatus{
    width: 100%;
    height: 100%;
    background-size: contain;
  }
</style>
<style scoped>
.buttons {
  margin-top: 35px;
}
.ghost {
  opacity: 0.5;
}
.materias{
  width: 140px;
  cursor: pointer;
  margin: 3px;
}
.nombreMateria{
  height: 80px;
  justify-content: center;
  display: flex;
  align-items: center;
}
.borderInfo{
  border-bottom: 1px solid #D7DBDD;
  border-left: 1px solid #D7DBDD;
  border-right: 1px solid #D7DBDD;
  border-radius: 0 0 5px 5px;
  text-align: center;
  font-size: 11px;
  font-weight:500;
}
.asig-aprobada{
  background-color: yellowgreen;
  border-radius: 5px 5px 0 0;
  color: white;
  font-weight: bold;
  font-size: 12px;
}
.asig-acreditada{
  background-color:#2D9CDB;
  border-radius: 5px 5px 0 0;
  color: white;
  font-weight: bold;
  font-size: 12px;
}
.asig-vigente{
  background-color:#F2994A;
  border-radius: 5px 5px 0 0;
  color: white;
  font-weight: bold;
  font-size: 12px;
}
.asig-no-aprobada{
  background-color:#EB5757;
  border-radius: 5px 5px 0 0;
  color: white;
  font-weight: bold;
  font-size: 12px;
}
.asig-disponible{
  background-color:#BB6BD9;
  border-radius: 5px 5px 0 0;
  color: white;
  font-weight: bold;
  font-size: 12px;
}
.asig-no-disponible{
  background-color:#828282;
  border-radius: 5px 5px 0 0;
  color: white;
  font-weight: bold;
  font-size: 12px;
}
.borderInfo p{
  margin-bottom: 0;
}

</style>